import message from '../components/Message'
import modal from '../components/Modal'
import sidebar from '../components/Sidebar'
import loadmore from '../components/Loadmore'
import constatus from '../components/ConStatus'
import onerror from '../components/OnError'
import emptylist from '../components/emptylist'
import errmsg from '../components/errmsg'


import {
  Roles,
  login,
  logout,
  getUser,
  isAuth,
  isAllowed,
  isTokenExpired,
  getToken
} from '../modules/session'
import RPC from '../modules/server'
import Settings from '../modules/settings'

let tools = {}

function isEmpty(obj) {
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  // null and undefined are "empty"
  if (obj == null) return true;

  // Assume if it has a length property with a non-zero value
  // that that property is correct.
  if (obj.length > 0) return false;
  if (obj.length === 0) return true;

  // Otherwise, does it have any properties of its own?
  // Note that this doesn't handle
  // toString and valueOf enumeration bugs in IE < 9
  for (var key in obj) {
    if (hasOwnProperty.call(obj, key)) return false;
  }

  return true;
}

tools.install = function (Vue, options) {
  // 1. add global method or property
  Vue.myGlobalMethod = function () {
      // something logic ...
      console.log('Global')
    }
    // 2. add a global asset
/*  Vue.directive('my-directive', {
    bind(el, binding, vnode, oldVnode) {
      // something logic ...
    }
  }) */
/*
  Vue.directive('focus', {
    bind(el) {
         Vue.nextTick(() => {
        el.focus();
    });
        
    }
});*/

Vue.directive('focus', {
  // When the bound element is inserted into the DOM...
  inserted: function (el) {
    // Focus the element
    el.focus()
  }
})



  // 3. inject some component options
  Vue.component('message', message);
  Vue.component('modal', modal);
  Vue.component('sidebar', sidebar);
  Vue.component('loadmore', loadmore);
  Vue.component('constatus', constatus);
  Vue.component('onerror', onerror);
  Vue.component('emptylist', emptylist);
  Vue.component('errmsg', errmsg);

/*
  Vue.config.errorHandler = function (err, vm) {
    console.log(err)
  }
*/


  // mixin
  Vue.mixin({
      data() {
        return {
          //Roles: Roles
        }
      },
      created: function () {
        // something logic ...
      }

    })
    // 4. add an instance method
  Vue.prototype.$server = {}
  Vue.prototype.$server.rpc = RPC
  Vue.prototype.$userRoles = Roles
  Vue.prototype.$getUser = getUser
  Vue.prototype.$login = login
  Vue.prototype.$logout = logout
  Vue.prototype.$isAuth = isAuth
  Vue.prototype.$isAllowed = isAllowed
  Vue.prototype.$isTokenExpired = isTokenExpired
  Vue.prototype.$getToken = getToken
  Vue.prototype.$isEmpty = isEmpty
  Vue.prototype.$formatDateTime = function (date) {
    date = new Date(date)
    return date.toDateString() + ' ' + date.toLocaleTimeString();
  }

  Vue.prototype.$formatDate = function (date) {
    date = new Date(date)
    return date.toString().substr(0, 16);
  }
  Vue.prototype.$isMobile = Vue.util.isAndroid || Vue.util.isIOS ? true : false
  Vue.prototype.$capitalize = Vue.util.capitalize
  Vue.prototype.$plural = function (unit, qty) {
    if (unit !== null && qty !== null) {
      return unit !== null && qty > 1 ? unit + 's' : unit;
    }
  }
  Vue.prototype.$streamUrl = Settings.serverUrl + 'stream'
  Vue.prototype.$imgUrl = function (url) {
    return url !== null ? Settings.imagesUrl + url : Settings.imagesUrl + 'placeholder.png';
  }
  Vue.prototype.$calcPrice = function (item) {
      if (item) {
        return item.o >= item.p.wq ? item.p.wp : item.p.rp;
      }
    },
    Vue.prototype.$calcOrderAmt = function (item) {
      if (item) {
        return item.o < item.p.wq ? Math.round(item.o * item.p.rp) : Math.round(item.o * item.p.wp)
      }
    }

}

export default tools



// WEBPACK FOOTER //
// ./src/plugins/toolbox.js